import { render, staticRenderFns } from "./PointsChanges.vue?vue&type=template&id=767f5c38&scoped=true"
import script from "./PointsChanges.vue?vue&type=script&lang=js"
export * from "./PointsChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f5c38",
  null
  
)

export default component.exports